module.exports = __webpack_public_path__ + "img/steam-china.a60af245.png";